import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { isEditUserSettingsCategoryDrawer, isOpenUserSettingsCategoryDrawer, userSettingCategoryFormData } from "../../../@signals"
import UserSettingCategoryDrawerColor from "./Color"
import UserSettingCategoryDrawerCategory from "./Category"
import UserSettingCategoryDrawerSubmit from "./Submit"


export default function UserSettingCategoryDrawer() {

	return <DrawerSeeker
		hideActions
		title={isEditUserSettingsCategoryDrawer.value ? 'Edit category' : 'New category'}
		isOpen={isOpenUserSettingsCategoryDrawer.value}
		controller={() => userSettingCategoryFormData.value = { }}
		successText="save"
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<UserSettingCategoryDrawerCategory />
			</Grid>

			<Grid item xs={12}>
				<UserSettingCategoryDrawerColor />
			</Grid>

			<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
				<UserSettingCategoryDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}